import {
  createStyles,
  IconButton,
  Link,
  makeStyles,
  Menu,
  MenuItem,
  Theme
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import MenuIcon from "@material-ui/icons/Menu";
import React from "react";
import { useQueryParams } from "../utils/queryParams";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      position: "absolute",
      width: "100%",
      zIndex: 101,
      top: 0,
    },
    headerWrapper: {
      padding: 24,
      display: "flex",
      [theme.breakpoints.down("sm")]: {
        padding: 4,
      },
    },
    button: {
      background: "none",
      border: "none",
      color: "#E9F400",
      cursor: "pointer",
    },
    imgWrapper: {
      width: 175,
      display: "flex",
      alignItems: "center",
      [theme.breakpoints.down("sm")]: {
        width: 100,
      },
    },
    img: {
      width: "100%",
    },
  })
);

const Header = () => {
  const classes = useStyles();
  const queryParams = useQueryParams();

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div className={classes.root}>
      <div className={classes.headerWrapper}>
        <div>
          <IconButton
            onClick={(e) => {
              e.preventDefault();
              handleClick(e);
            }}
            className={classes.button}
            size="medium"
          >
            {Boolean(anchorEl) ? (
              <CloseIcon fontSize="large" />
            ) : (
              <MenuIcon fontSize="large" />
            )}
          </IconButton>
          <Menu
            anchorEl={anchorEl}
            keepMounted
            open={Boolean(anchorEl)}
            onClose={handleClose}
            variant="menu"
            getContentAnchorEl={null}
            anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
            transformOrigin={{ vertical: "top", horizontal: "center" }}
          >
            <MenuItem
              href={`/startsit/NFL?site=espn_ppr&token=${
                queryParams.get("token") || ""
              }`}
              component="a"
            >
              Fantasy Football Start/Sit
            </MenuItem>
            <MenuItem href="https://stokastic.com" component="a">
              Stokastic Homepage
            </MenuItem>
          </Menu>
        </div>
        <Link
          // href={`/playercompare/${routeParams.league}?site=dk&token=${
          //   queryParams.get("token") || ""
          // }`}
          className={classes.imgWrapper}
        >
          <img
            src={`${process.env.PUBLIC_URL}/images/logo.png`}
            alt=""
            className={classes.img}
          />
        </Link>
      </div>
    </div>
  );
};

export default Header;
